import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { microTask as i } from './micro-task.js';
function o() {
  var n = [],
    r = {
      addEventListener: function addEventListener(e, t, s, a) {
        return e.addEventListener(t, s, a), r.add(function () {
          return e.removeEventListener(t, s, a);
        });
      },
      requestAnimationFrame: function (_requestAnimationFrame) {
        function requestAnimationFrame() {
          return _requestAnimationFrame.apply(this, arguments);
        }
        requestAnimationFrame.toString = function () {
          return _requestAnimationFrame.toString();
        };
        return requestAnimationFrame;
      }(function () {
        var t = requestAnimationFrame.apply(void 0, arguments);
        return r.add(function () {
          return cancelAnimationFrame(t);
        });
      }),
      nextFrame: function nextFrame() {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }
        return r.requestAnimationFrame(function () {
          return r.requestAnimationFrame.apply(r, e);
        });
      },
      setTimeout: function (_setTimeout) {
        function setTimeout() {
          return _setTimeout.apply(this, arguments);
        }
        setTimeout.toString = function () {
          return _setTimeout.toString();
        };
        return setTimeout;
      }(function () {
        var t = setTimeout.apply(void 0, arguments);
        return r.add(function () {
          return clearTimeout(t);
        });
      }),
      microTask: function microTask() {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }
        var t = {
          current: !0
        };
        return i(function () {
          t.current && e[0]();
        }), r.add(function () {
          t.current = !1;
        });
      },
      style: function style(e, t, s) {
        var a = e.style.getPropertyValue(t);
        return Object.assign(e.style, _defineProperty({}, t, s)), this.add(function () {
          Object.assign(e.style, _defineProperty({}, t, a));
        });
      },
      group: function group(e) {
        var t = o();
        return e(t), this.add(function () {
          return t.dispose();
        });
      },
      add: function add(e) {
        return n.push(e), function () {
          var t = n.indexOf(e);
          if (t >= 0) {
            var _iterator = _createForOfIteratorHelper(n.splice(t, 1)),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var s = _step.value;
                s();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        };
      },
      dispose: function dispose() {
        var _iterator2 = _createForOfIteratorHelper(n.splice(0)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var e = _step2.value;
            e();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    };
  return r;
}
export { o as disposables };